import React from "react";
import { Code, Box } from "lucide-react";
import {
  InboxStackIcon,
  RectangleGroupIcon,
} from "@heroicons/react/24/outline";
import { replaceRawWithBlob } from "components/utils";
import { SimpleContainerOverview } from "components/Environment/shared/ContainerOverview";
import { ContainerSelected } from "components/Environment/shared/BuildTypes";

interface ContainerPieceProps {
  python: string;
  cuda: string;
  container: ContainerSelected;
}

export const ContainerPiece: React.FC<ContainerPieceProps> = ({
  python,
  cuda,
  container,
}) => {
  return (
    <div className="flex flex-col h-full items-start">
      <div className="flex flex-row items-center text-primary text-sm mb-2">
        <RectangleGroupIcon className="h-6 w-6 mr-1" />
        <span>Container</span>
      </div>
      <div className="flex flex-col">
        <SimpleContainerOverview
          pythonVersion={python || ""}
          cudaVersion={cuda || ""}
          containerSelected={container}
        />
      </div>
    </div>
  );
};
